import React, { useEffect } from 'react'
import Layout from 'components/Layout'
import ReportingCategoriesForm from 'components/ReportingCategories/Form'
import { useDispatch, useSelector } from 'react-redux'
import { loadGlobalItems } from 'store/Items/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import Loader from 'components/Loader'
import { getIsItemsLoading } from 'store/Items/selector'

const ReportingCategoriesDeails = () => {
  const dispatch = useDispatch()
  const venueUuid = useSelector((state) => getCurrentVenueUuid(state))
  const isItemsLoading = useSelector(getIsItemsLoading)

  useEffect(() => {
    dispatch(loadGlobalItems(venueUuid))
  }, [dispatch, venueUuid])

  const isLoading = isItemsLoading

  return (
    <Layout
      backTo="/reporting-categories"
      iconType="back"
      isSidebar
      mainContent={
        isLoading ? <Loader /> : <ReportingCategoriesForm />
      }
    />
  )
}

export default ReportingCategoriesDeails
